export default __webpack_public_path__ + "static/media/SanjoyPaul_Web_Developer.01071a74.pdf";